const types = {
	//Get Template name
	GET_TECHNICALDOCUMENT_START: "GET_TECHNICALDOCUMENT_START",
	GET_TECHNICALDOCUMENT_SUCCESS: "GET_TECHNICALDOCUMENT_SUCCESS",
	GET_TECHNICALDOCUMENT_ERROR: "GET_TECHNICALDOCUMENT_ERROR",
	GET_TECHNICALDOCUMENT_RESET: "GET_TECHNICALDOCUMENT_RESET",

	//Create Template name
	CREATE_TECHNICALDOCUMENT_START: "CREATE_TECHNICALDOCUMENT_START",
	CREATE_TECHNICALDOCUMENT_SUCCESS: "CREATE_TECHNICALDOCUMENT_SUCCESS",
	CREATE_TECHNICALDOCUMENT_ERROR: "CREATE_TECHNICALDOCUMENT_ERROR",
	CREATE_TECHNICALDOCUMENT_RESET: "CREATE_TECHNICALDOCUMENT_RESET",

	//delete Template name
	DELETE_TECHNICALDOCUMENT_START: "DELETE_TECHNICALDOCUMENT_START",
	DELETE_TECHNICALDOCUMENT_SUCCESS: "DELETE_TECHNICALDOCUMENT_SUCCESS",
	DELETE_TECHNICALDOCUMENT_ERROR: "DELETE_TECHNICALDOCUMENT_ERROR",
	DELETE_TECHNICALDOCUMENT_RESET: "DELETE_TECHNICALDOCUMENT_RESET",

	//update Template name
	UPDATE_TECHNICALDOCUMENT_START: "UPDATE_TECHNICALDOCUMENT_START",
	UPDATE_TECHNICALDOCUMENT_SUCCESS: "UPDATE_TECHNICALDOCUMENT_SUCCESS",
	UPDATE_TECHNICALDOCUMENT_ERROR: "UPDATE_TECHNICALDOCUMENT_ERROR",
	UPDATE_TECHNICALDOCUMENT_RESET: "UPDATE_TECHNICALDOCUMENT_RESET",

	//single item  name
	SINGLE_TECHNICALDOCUMENT_START: "SINGLE_TECHNICALDOCUMENT_START",
	SINGLE_TECHNICALDOCUMENT_SUCCESS: "SINGLE_TECHNICALDOCUMENT_SUCCESS",
	SINGLE_TECHNICALDOCUMENT_ERROR: "SINGLE_TECHNICALDOCUMENT_ERROR",
	SINGLE_TECHNICALDOCUMENT_RESET: "SINGLE_TECHNICALDOCUMENT_RESET",
};

export default types;
